$(function() {

    if ( $(".thx-hero").length ) {
        var header = $(".header");
        var footer = $(".footer");
        var sum = header.outerHeight() + footer.outerHeight();
        // console.log(sum);
        $(".thx-hero__main").css("min-height", "calc(100vh - " + sum + "px" + ")");
    }

});